import Link from "next/link"
import SbEditable from "storyblok-react"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"
import getTarget from "utilities/getTarget"
import Arrow from "public/assets/white-arrow.svg"

export function InlineCard({ title, link, children }) {
  return (
    <article className="relative py-6 pl-6 pr-16 sm:pr-24 bg-blue-light">
      <h2 className="text-base font-primary uppercase leading-6 pb-2">{title}</h2>
      <div className="prose-p:font-light prose-p:font-secondary last-of-type:prose-p:pb-2 prose-p:leading-6">
        {children}
      </div>
      <Link href={link} target={getTarget(link)} className="bg-purple absolute bottom-0 right-0 p-4" title={title}>
        <Arrow />
      </Link>
    </article>
  )
}

export default function InlineCards({ blok }) {
  return (
    <div className="grid lg:grid-cols-2 gap-8 py-2">
      {blok.cards.map((card) => (
        <SbEditable content={card} key={card.title}>
          <InlineCard title={card.title} link={getStoryblokLink(card.link)}>
            {richText(card.content)}
          </InlineCard>
        </SbEditable>
      ))}
    </div>
  )
}
